import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=fe4007b4&lang=css"

const __exports__ = script;

export default __exports__